import React from "react";
import Blink from "./Blink.js"

export default function Title(props) {
  const currentSlide = props.currentSlide;
  if (!currentSlide.title) {
    return null;
  }
  
  return (
    <div
      // id={"Title"}
      style={{
        position: "fixed",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: "100",
        flexDirection: "column",
        opacity: "0.8",
        backgroundColor: "#33383d",
        pointerEvents: "none",
        width: "100vw",
        height: "100vh",
        WebkitTransition: "opacity 2s",
      }}
      // className={`scrollable-video__container`}
    >
      {currentSlide.title.split("\r\n\r\n").map((p, i) => (
        <div
          key={i}
          style={{
            color: "white",
            fontWeight: i===0 ?"650": "normal",
            fontSize: props.isMobile? (i===0? "7.5vw": (i===1) ? "5vw":"3vw"):(i===0? "3vw": (i===1) ? "1.4vw":"1.4vw"),
            fontStyle: i===1 ?"italic": "normal",
            textAlign: "center",
            margin: props.isMobile? "1vw 5vw":"1vw 20vw",
            padding: props.isMobile? "1vw":"0vw",
          }}
        >
          {p}
      </div> 
      ))}
          <Blink>
          <div
              style={{
                borderLeft: "1px white solid",
                height: props.isMobile? "10vw":"4vw",
                display: "inline-block",
                padding: props.isMobile? "1vw":"1vvw",
              }}
            />
          </Blink>
          <Blink>
          <div
              style={{
                color: "white",
                fontSize: props.isMobile? "3vw":"1vw",
              }}
            >Scroll
        </div>
        </Blink>
        </div>
  );
}

